$.fn.SectionPopup = function() {
  let self = this

  self.closest('.page-section').addClass('section-popup__wrapper')

  self.find('.section-popup__toggler').click(function() {
    self.toggleClass('--open')
  })

  return function() {
    return self
  }()
}
